/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { UnfiledRecordFolderAssociationPaging } from '../model/unfiledRecordFolderAssociationPaging';
import { UnfiledRecordFolderEntry } from '../model/unfiledRecordFolderEntry';
import { BaseApi } from './base.api';
import { buildCollectionParam } from '../../../alfrescoApiClient';
import { throwIfNotDefined } from '../../../assert';
export class UnfiledRecordFoldersApi extends BaseApi {
    createUnfiledRecordFolderChildren(unfiledRecordFolderId, nodeBodyCreate, opts) {
        throwIfNotDefined(unfiledRecordFolderId, 'unfiledRecordFolderId');
        throwIfNotDefined(nodeBodyCreate, 'nodeBodyCreate');
        const pathParams = {
            unfiledRecordFolderId
        };
        const queryParams = {
            autoRename: opts === null || opts === void 0 ? void 0 : opts.autoRename,
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.post({
            path: '/unfiled-record-folders/{unfiledRecordFolderId}/children',
            pathParams,
            queryParams,
            bodyParam: nodeBodyCreate,
            contentTypes: ['application/json', 'multipart/form-data'],
            returnType: UnfiledRecordFolderAssociationPaging
        });
    }
    deleteUnfiledRecordFolder(unfiledRecordFolderId) {
        throwIfNotDefined(unfiledRecordFolderId, 'unfiledRecordFolderId');
        const pathParams = {
            unfiledRecordFolderId
        };
        return this.delete({
            path: '/unfiled-record-folders/{unfiledRecordFolderId}',
            pathParams
        });
    }
    getUnfiledRecordFolder(unfiledRecordFolderId, opts) {
        throwIfNotDefined(unfiledRecordFolderId, 'unfiledRecordFolderId');
        const pathParams = {
            unfiledRecordFolderId
        };
        const queryParams = {
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            relativePath: opts === null || opts === void 0 ? void 0 : opts.relativePath,
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.get({
            path: '/unfiled-record-folders/{unfiledRecordFolderId}',
            pathParams,
            queryParams,
            returnType: UnfiledRecordFolderEntry
        });
    }
    listUnfiledRecordFolderChildren(unfiledRecordFolderId, opts) {
        throwIfNotDefined(unfiledRecordFolderId, 'unfiledRecordFolderId');
        opts = opts || {};
        const pathParams = {
            unfiledRecordFolderId
        };
        const queryParams = {
            skipCount: opts === null || opts === void 0 ? void 0 : opts.skipCount,
            maxItems: opts === null || opts === void 0 ? void 0 : opts.maxItems,
            where: opts === null || opts === void 0 ? void 0 : opts.where,
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            relativePath: opts === null || opts === void 0 ? void 0 : opts.relativePath,
            includeSource: opts === null || opts === void 0 ? void 0 : opts.includeSource,
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.get({
            path: '/unfiled-record-folders/{unfiledRecordFolderId}/children',
            pathParams,
            queryParams,
            returnType: UnfiledRecordFolderAssociationPaging
        });
    }
    updateUnfiledRecordFolder(unfiledRecordFolderId, unfiledRecordFolderBodyUpdate, opts) {
        throwIfNotDefined(unfiledRecordFolderId, 'unfiledRecordFolderId');
        throwIfNotDefined(unfiledRecordFolderBodyUpdate, 'unfiledRecordFolderBodyUpdate');
        const pathParams = {
            unfiledRecordFolderId
        };
        const queryParams = {
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            includeSource: opts === null || opts === void 0 ? void 0 : opts.includeSource,
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.put({
            path: '/unfiled-record-folders/{unfiledRecordFolderId}',
            pathParams,
            queryParams,
            bodyParam: unfiledRecordFolderBodyUpdate,
            returnType: UnfiledRecordFolderEntry
        });
    }
}
